import styled from 'styled-components';
import { getTextTokenPreset, getToken } from '@optimus-web/common';

export const AppCanvas = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    height: 100svh;
    background-color: ${getToken('backgroundStaticSunken')};
    ${getTextTokenPreset('bodyLarge')}
    color: ${getToken('textStaticPrimary')};
`;

interface AppViewProps {
    offset?: number;
}

export const AppView = styled.main<AppViewProps>`
    position: relative;
    overflow: hidden;
    height: calc(100% - ${(props) => props.offset}px);
    top: ${(props) => props.offset}px;
`;
AppView.defaultProps = { offset: 0 };

export const AppContent = styled.div`
    height: 100%;
    overflow: auto;
    position: relative;
`;
